/* 布局 */
//前台
import Layout from "@views/layout";

const userpermissionRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "userpermission",
            name: "USERPERMISSION",
            meta: {
                title: "授权管理",
                sort: 1,
            },
            component: () => import("@views/business/userpermission/index.vue"),
            redirect: {
                name: "USERPERMISSION_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "USERPERMISSION_LIST",
                    meta: {
                        title: "授权管理",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/userpermission/list.vue"),
                },
                                {
                    path: "add",
                    name: "USERPERMISSION_ADD",
                    meta: {
                        title: "新增用户-模块权限关联表",
                        parentPath: '/business/userpermission/list',
                        operate: true,
                    },
                    component: () => import("@views/business/userpermission/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "USERPERMISSION_EDIT",
                    meta: {
                        title: "编辑用户-模块权限关联表",
                        parentPath: '/business/userpermission/list',
                        operate: true,
                    },
                    component: () => import("@views/business/userpermission/form.vue"),
                },
                                        ],
    },


        ],
};

export default userpermissionRouter;
